<div id="notfound-screen" [style.backgroundImage]="'url(' + backgroundImage + ')'">
  <div class="information-wrapper">
    <div class="information">
      <h1>{{ 'pageNotFoundMsg' | i18n }}</h1>
      <a href="/" class="btn btn-info">{{ 'returnToSiteTop' | i18n }}</a>
    </div>
  </div>
</div>
